/**
 * Decides whether an HTTP error means "the portal session is dead, sign the user out".
 *
 * A 401 from a portal endpoint means our own token is invalid → sign out.
 * A 401 from `/api/sso/launch` means something quite different: the PORTAL session is
 * fine, but the TARGET APP rejected the user (no account there, wrong app password,
 * inactive account). Signing the user out of the portal for that is wrong — it throws
 * away a valid session and dumps them on the login page, which is what made a failed
 * "Open CBT" look like a portal logout.
 *
 * Kept free of Angular imports so it is trivially verifiable on its own.
 */
export function shouldForceLogout(status: number, url: string): boolean {
  if (status !== 401) return false;
  return !isTargetAppAuthEndpoint(url);
}

/** Endpoints where a 401 describes the TARGET APP's verdict, not the portal session. */
export function isTargetAppAuthEndpoint(url: string): boolean {
  const path = String(url || '').split('?')[0];
  return path.includes('/api/sso/launch') || path.includes('/api/sso/prewarm');
}
